module.exports = __webpack_public_path__ + "img/author-empty-list-dark.61efbb2d.svg";